
import HTMLRenderer from './../../zviz2/zviz/renderers/html';

import Group from './../../zviz2/zviz/components/group';
import SimpleEvent from './../../zviz2/zviz/event';
import Model from './model';

import Main from './../pack/blueprint';

import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {getSizeWatcher} from './../../zviz2/zviz/environment/window';
import state from './../../zviz2/zviz/state';
import global from './../../zviz2/zviz/global';
import {scrollTo} from './../../tools';


class Component{

    constructor(settings={}){
        
        settings = extend(settings, {
            container: 'canvas',
            height: 500,
            width: 'auto',
            minScaleFactor: 0.1,
            data: [],
        });

        this.objects = [];
        this.objects.push(getSizeWatcher());

        let model = new Model('staticModel' + Math.round(99999*Math.random()), 
                { 
                    data: cloneObject(settings.data), 
                }
            );

        this.objects.push();

        let Bubbles = extend({
            models: {
                'pack': model
            },
            properties: {
                data: {
                    height: settings.height,
                    width: settings.width,
                    minScaleFactor: 0.5,
                    opacity: 1,
                    showValueOnHover: true,
                }
            }
        }, Main);

        let Blueprint = extend({
            children: [
                cloneObject(Bubbles),
            ],
            properties: {
                style: { 
                    position: 'relative'
                 },
            },
            listeners: [
                (ctrl) => ( ctrl.addListener(state, [this, this.filterChange], 'filter.theme') )
            ],
            private: {
                callback: [this, this.filterChange],
                filterName : this.filterName
            }
        }, Group);

        let container = settings.container;
        if(typeof container == 'string'){
            container = document.getElementById(container);
        }

        let renderer = new HTMLRenderer();
        renderer.setCanvas(container);
        renderer.start(Blueprint);

        this.objects.push(renderer);

        let elms = document.getElementsByClassName('closeThemeInfo');
        for(let elm of elms){
            this.objects.push(new SimpleEvent(elm, 'click', [this, this.closeThemeInfo]));
        }

    }

    closeThemeInfo(event){
        event.preventDefault();
        state.set('filter.theme', null);
        if(state.get('windowSize.width') < 700){
            let elm = document.getElementById('bubbles');
            let c = scrollTo(elm, 300, true, 40);
            c.start();
        }
    }

    filterChange(){
        let themeId = state.get('filter.theme');

        let elms = document.getElementsByClassName('themeInfo');
        for(let i = 0; i < elms.length; i++){
            elms[i].style.display = 'none';
        }
        if(! themeId){
            themeId = 'selectTheme';
        }
        let elm = document.getElementById(themeId);
        if(! elm){
            elm = document.getElementById('selectTheme');
        }
        elm.style.display = 'block';
        if(state.get('windowSize.width') < 700){
            let elm = document.getElementsByClassName('themeHighlights');
            if(elm[0]){
                let c = scrollTo(elm[0], 300, true, 40);
                c.start();
            }
        }
    }

    remove(){
        for(let o of this.objects){
            if(! (o instanceof Function)){
                o.remove();
            }
        }
        delete this.objects;
    }

}    

export default Component;

